import React from "react";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { makeStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { tesaBlue, tesaRed } from "../../styles/colors";

interface CustomLinkButtonProps {
  addPlusSign?: boolean;
  addMinusSign?: boolean;
  bold?: boolean;
  disabled?: boolean;
  onClick: () => void;
  textColor?: string;
}

const useStyles = makeStyles({
  root: {
    color: (props: CustomLinkButtonProps) => (props.addMinusSign ? tesaRed : tesaBlue),
    fontSize: "0.875rem",
    lineHeight: "1rem",
    letterSpacing: 1.25,
    paddingLeft: 0,
    paddingRight: 0,
    textTransform: "uppercase",
    fontFamily: "Proxima Nova Bold",
  },
  icon: {
    fontSize: "1rem",
    marginRight: "0.25rem",
  },
});

const CustomLinkButton: React.FC<CustomLinkButtonProps> = (props) => {
  const classes = useStyles(props);
  const { addPlusSign, addMinusSign, children, disabled, onClick, textColor } = props;

  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      variant="text"
      color="secondary"
      className={classes.root}
      style={textColor ? { color: textColor } : undefined}
    >
      {addPlusSign && <AddIcon className={classes.icon} />}
      {addMinusSign && <RemoveIcon className={classes.icon} />}
      {children}
    </Button>
  );
};

export default CustomLinkButton;
